import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { LineChartConfig } from 'src/app/core/types/chart-types';
import { CustomerServiceInsightsService } from '../../services/customer-service-insights.service';
import { Router } from '@angular/router';
import { MixpanelService } from 'src/app/core/services/mixpanel.service';
import { AuthenticationService } from 'src/app/core/services/authentication.service';



@Component({
    selector: 'ph-location-details',
    templateUrl: './location-details.component.html',
    styleUrls: ['./location-details.component.scss'],
    standalone: false
})

export class LocationDetailsComponent implements OnInit {

  isLoading: boolean = false;
  selectedAccount: string | null = null;

  gaugeNeedleValue: number = 70;
  lineChartConfig!: LineChartConfig;
  haslocationPerformanceData: boolean = false;

  locationName: string = '';
  cityState: string = '';

  private subscription: Subscription = new Subscription();

  constructor(
    private router: Router,
    private _mixpanelService: MixpanelService,
    private _customerServiceInsightsService: CustomerServiceInsightsService,
    private _authenticationservice: AuthenticationService, // Inject CustomerService
  ) {
    const navigation = this.router.currentNavigation();
    if (navigation?.extras.state) {
      this.selectedAccount = navigation.extras.state['accountNumber'];
      this.locationName = navigation.extras.state['locationName'];
      this.cityState = navigation.extras.state['geography'];
    }
   }

  ngOnInit(): void {
    this.setChartsConfigOptions();

    this.isLoading = true;
    this._customerServiceInsightsService.setAccountNumber(this.selectedAccount);
    this.subscribeToPerformanceData();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private subscribeToPerformanceData(): void {
    this.isLoading = true;
    this.subscription = this._customerServiceInsightsService.singleLocationPerformanceData$.subscribe(
      locationData => {
        this.updateLocationPerformanceData(locationData);
        this.isLoading = false;
      }
    )
  }

  public updateLocationPerformanceData(data: any): void {
    if (data) {
      this.gaugeNeedleValue = data.gaugeNeedleValue;
      this.lineChartConfig = {
        ...this.lineChartConfig,
        xAxis: data.lineChartData.xAxis,
        yAxis: data.lineChartData.yAxis,
      };

      //Set the flags to true if location Performance data is available
      this.haslocationPerformanceData = data.gaugeNeedleValue !== 0 && data.lineChartData.yAxis.length > 0;
    } else {
      this.haslocationPerformanceData = false;
    }
  }

  setChartsConfigOptions(): void {
    //Set Options for Line chart configuration
    this.lineChartConfig = {
      xAxis: [],
      yAxis: [],
      xAxisDisplay: true,
      backgroundColor: "rgb(205, 235, 247)",
      borderColor: "rgb(76 172 229)",
      borderWidth: 2,
      yAxisMaxValue: 100,
      yAxisFontSize: 10,
      yAxisPadding: 30,
      yAxisInterval: 20,
      xAxisDisplayBorder: true,
      xAxisDisplayTicks: true,
      yAxisDrawOnChartArea: true,
      fillArea: false,
      showDottedSegment: true,
      pointRadius: 2,
      pointHoverRadius: 4,
      pointBackgroundColor: "rgb(76 172 229)",
      pointBorderColor: "rgb(76 172 229)",
      pointHoverBorderColor: "rgb(76 172 229)",
      applyExtraPadding: true,
      toolTipRequired: true,
      useSimpleTooltip: true,
      mixPanelEventNamePH : 'PH Performance rating line chart hovering data- location details page',
      mixPanelEventName : 'Chart is hovered for 2+ seconds',
      accountNumber: this.selectedAccount ?? '',
    };
  }

  trackLocationClick() {
    this._mixpanelService.track('PH Breadcrumb back to Overall page', {
      ImpersonatedCustomer: this._authenticationservice.customerName??" ",
      ImpersonatedUser:  this._authenticationservice.userName??" ",
    });
  }
}
